import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { onMessageListener } from "../../configs"

import { ACCOUNT, BOOKINGCALENDAR, MODAL, NOTIFICATION } from "../../reduxs"
import { StyleCalendar } from "./style"
import Topbar from "./Topbar"
import Month from "./Month"
import Year from "./Year"
import DayAndWeek from "./DayAndWeek"
import { Toast } from "../../components"

export class Calendar extends Component {
  componentDidMount() {
    const {setNotificationData, openAndCloseToast} =  this.props
    onMessageListener(setNotificationData, openAndCloseToast)
  }

  closeToast() {
    const {setNotificationData, closeNotification} =  this.props
    closeNotification()
    setNotificationData(null)
  }


  render() {
    const { view } = this.props

    return (
      <React.Fragment>
        <Toast 
          onClickCloseToast={() => this.closeToast()}
        />
        <Topbar {...this.props} />
        <StyleCalendar>
          <div className='div-content'>
            {view === "month" ? <Month {...this.props} /> : null}
            {view === "year" ? <Year {...this.props} /> : null}
            {view === "week" ? <DayAndWeek {...this.props} /> : null}
            {view === "day" ? <DayAndWeek {...this.props} /> : null}
          </div>
        </StyleCalendar>
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    accountAction: bindActionCreators(ACCOUNT.action, dispatch),
    bookingcalendarAction: bindActionCreators(BOOKINGCALENDAR.action, dispatch),
    modalAction: bindActionCreators(MODAL.action, dispatch),
    closeNotification: () => dispatch(NOTIFICATION.action.toggleNotification(false)),
    setNotificationData: (data) => dispatch(NOTIFICATION.action.setNotificationData(data)),
    openAndCloseToast: () => dispatch(NOTIFICATION.action.openAndCloseToast())
  }
}

export const mapStateToProps = ({
  accountReducer,
  loaderReducer,
  modalReducer,
  notificationReducer,
  settingReducer
}) => {
  return {
    accountReducer,
    loaderReducer,
    modalReducer,
    notificationReducer,
    settingReducer
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Calendar)
